import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useAlert } from "../Components/Alert.tsx";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { allDelete } from "../Redux/Actions.tsx";
import {
  urlreferenti,
  urlutenti,
  urltask,
  urleventi,
  urlcommittenti,
  urlcontratti,
  urlcantiere,
  urlfiles,
} from "../lib/api.ts";
import "./DeleteModal.css";

interface DeleteModalProps {
  type: string;
  idObj: string;
  matchIdentifier: string;
  show: boolean;
  onClose: () => void;
  onDeleteSuccess: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ type, idObj, matchIdentifier, show, onClose, onDeleteSuccess }) => {
  const [inputValue, setInputValue] = useState("");
  const [messageCascate, setMessageCascate] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const showAlert = useAlert();
  const dispatch: AppDispatch = useDispatch();
  const { token } = useSelector((state: RootState) => state.login);

  useEffect(() => {
    switch (type) {
      case "referente": {
        setMessageCascate(
          "Se elimini questo referente verrà eliminato ad ogni contratto associato in maniera irreversibile"
        );
        break;
      }
      case "utente": {
        setMessageCascate(
          "Se elimini questo utente verranno eliminati anche tutti i task a lui associati in maniera irreversibile"
        );
        break;
      }
      case "task": {
        setMessageCascate("L'eminazione di questo task non avrà conseguenze su altri dati ");
        break;
      }
      case "evento": {
        setMessageCascate(
          "Se elimini questo evento verranno eliminati tutti i task associati in maniera irreversibile"
        );
        break;
      }
      case "cantiere": {
        setMessageCascate(
          "Se elimini questo cantiere verranno eliminati tutti i task associati in maniera irreversibile"
        );
        break;
      }
      case "file": {
        setMessageCascate("");
        break;
      }
      case "contratto": {
        setMessageCascate(
          "Se elimini questo contratto verranno eliminati tutti i cantieri e i task ad esso associati in maniera irreversibile"
        );
        break;
      }
      case "committente": {
        setMessageCascate(
          "Se elimini questo cliente verranno eliminati tutti i contratti, cantieri ed eventi e i relativi referenti e task interni associati in maniera irreversibile"
        );
        break;
      }

      default:
        throw new Error(`Tipo non gestito: ${type}`);
    }
  }, []);

  const getDeleteUrl = (type: string): string => {
    switch (type) {
      case "referente":
        return urlreferenti;
      case "utente":
        return urlutenti;
      case "task":
        return urltask;
      case "evento":
        return urleventi;
      case "cantiere":
        return urlcantiere;
      case "contratto":
        return urlcontratti;
      case "committente":
        return urlcommittenti;
      case "file":
        return urlfiles;
      default:
        throw new Error(`Tipo non gestito: ${type}`);
    }
  };

  // const matchIdentifierField = (() => {
  //   switch (type) {
  //     case "referente":
  //     case "utente":
  //       return "cognome";
  //     case "task":
  //     case "evento":
  //       return "titolo";

  //     case "cantiere":
  //       return "nome";
  //     case "file":
  //       return "nome del file";
  //     case "contratto":
  //       return "codice";
  //     case "committente":
  //       return "ragione sociale";
  //     default:
  //       return "identificatore";
  //   }
  // })();

  const handleDelete = async () => {
    try {
      const deleteUrl = getDeleteUrl(type);
      const result = await dispatch(allDelete(deleteUrl, token, idObj, showAlert) as any);

      if (result === true) {
        showAlert(
          "warning",
          "Eliminato",
          `${type.charAt(0).toUpperCase() + type.slice(1).toLowerCase()} eliminato con successo.`,
          "bottom-end",
          3000
        );
        onDeleteSuccess();
        onClose();
      } else {
        showAlert(
          "danger",
          "Errore",
          result.message || `Errore durante l'eliminazione del ${type}.`,
          "bottom-end",
          3000
        );
      }
    } catch (error) {
      showAlert("danger", "Errore", "Errore durante la richiesta di eliminazione.", "bottom-end", 3000);
    }
  };

  return (
    <>
      {(show || isConfirmDialogOpen) && <div className="modal-backdrop-custom"></div>}

      <Modal
        show={show}
        onHide={onClose}
        centered
        className={isConfirmDialogOpen ? "modal-dimmed" : ""}
        style={{ zIndex: "9999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Elimina {type}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Sei sicuro di voler eliminare questo {type}?</p>
          <p>{messageCascate}</p>
          <p>
            Per confermare, scrivi per esteso la parola <b>"ELIMINA"</b> corretto :
          </p>
          <Form.Control
            type="text"
            placeholder={`Inserisci la parola elimina`}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" disabled={inputValue !== "elimina"} onClick={() => setIsConfirmDialogOpen(true)}>
            Conferma eliminazione
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={isConfirmDialogOpen}
        onHide={() => setIsConfirmDialogOpen(false)}
        centered
        style={{ zIndex: "19999" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Conferma eliminazione</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Sicuro di voler eliminare?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleDelete}>
            Sì
          </Button>
          <Button variant="secondary" onClick={() => setIsConfirmDialogOpen(false)}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteModal;
